import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Tableau de trésorerie gratuit : modèle + outil en ligne | Trezoone',
    description: 'Créez votre tableau de trésorerie gratuitement. Modèle prêt à l\'emploi ou outil en ligne Trezoone (14 jours d\'essai offerts).',
    canonical: '/tableau-tresorerie-gratuit',
    keywords: 'tableau trésorerie gratuit, tableau de tresorerie, modele tableau tresorerie gratuit, outil tresorerie gratuit',
  },
  hero: {
    tag: 'Tableau de trésorerie gratuit',
    title: 'Un tableau de trésorerie gratuit — et un outil qui le fait à votre place.',
    subtitle: 'Commencez avec notre modèle ou gagnez du temps avec Trezoone. Dans les deux cas, vous aurez une vision claire de votre cash.',
    ctaLabel: 'Essai gratuit 14 jours',
  },
  pilierLink: { label: 'Guide plan de trésorerie', href: '/plan-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'Qu\'est-ce qu\'un tableau de trésorerie ?',
      content: 'Un tableau de trésorerie (ou plan de trésorerie) est un document qui récapitule mois par mois :',
      items: [
        'Tous les encaissements prévus ou réalisés (recettes, subventions, aides)',
        'Tous les décaissements prévus ou réalisés (charges, salaires, fournisseurs)',
        'Le solde net de chaque mois et le solde cumulé',
        'Les mois où la trésorerie devient tendue ou négative',
      ],
    },
    {
      type: 'example',
      title: 'Structure d\'un tableau de trésorerie gratuit type',
      content: 'Voici la structure d\'un tableau fonctionnel pour démarrer :',
      items: [
        'Colonne A : Catégorie (encaissement ou décaissement)',
        'Colonnes B à M : Mois de janvier à décembre (ou 12 mois glissants)',
        'Lignes encaissements : Ventes, Subventions, Remboursements, Autres recettes',
        'Lignes décaissements : Salaires, Charges sociales, Loyer, Fournisseurs, Emprunts, Impôts',
        'Ligne solde mensuel : Total encaissements - Total décaissements',
        'Ligne solde cumulé : = solde cumulé mois précédent + solde mensuel',
      ],
    },
    {
      type: 'midcta',
      title: 'Votre tableau gratuit vous prend 2 heures par mois — et risque de vous coûter plus',
      content: 'Passez à Trezoone : connexion bancaire automatique, alertes intégrées et prévisions sur 12 mois. Essai gratuit 14 jours.',
    },
    {
      type: 'solution',
      title: 'Pourquoi Trezoone est mieux qu\'un tableau gratuit',
      content: 'Un tableau gratuit est un bon départ. Mais Trezoone l\'améliore sur tous les points :',
      items: [
        'Connexion bancaire : plus de ressaisie manuelle',
        'Mise à jour automatique : votre tableau est toujours à jour',
        'Alertes intégrées : vous êtes prévenu avant les tensions',
        'Scénarios de simulation : testez des hypothèses en un clic',
        'Partage : accès pour votre comptable, votre CA, votre banquier',
      ],
    },
    {
      type: 'cluster',
      title: 'Modèles et outils de trésorerie',
      links: [
        { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
        { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
        { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
        { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
      ],
    },
    {
      type: 'cta',
      title: 'Tableau gratuit ou outil dédié ?',
      content: 'Testez Trezoone 14 jours gratuitement. Vous décidez ensuite.',
    },
  ],
  relatedLinks: [
    { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Excel trésorerie association', href: '/excel-tresorerie-association' },
    { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
    { label: 'Prévision trésorerie', href: '/prevision-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
    { label: 'Logiciel trésorerie', href: '/logiciel-tresorerie' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TableauTresorerieGratuitPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
